// extracted by mini-css-extract-plugin
module.exports = {"style":"ECX0R2ZS"};